import { render } from "./LinkerView.vue?vue&type=template&id=22e70c20&scoped=true"
import script from "./LinkerView.vue?vue&type=script&lang=js"
export * from "./LinkerView.vue?vue&type=script&lang=js"

import "./LinkerView.vue?vue&type=style&index=0&id=22e70c20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e70c20"]])

export default __exports__